// extracted by mini-css-extract-plugin
export default {"overlay":"DownloadOverlay_overlay__YzN3i","downloadCard":"DownloadOverlay_downloadCard__6uoN4","closeIcon":"DownloadOverlay_closeIcon__bv88U"};